export default function Avatar({ size, source, link }) {
  return <img src={source} className={`w-${size} h-${size} rounded-full`} />;
}
